var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDenmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.992634C22.3139 0.993106 22.6743 1.12635 22.9401 1.36315C23.2059 1.59994 23.3555 1.92097 23.356 2.25585V19.962C23.3555 20.2968 23.2059 20.6179 22.9401 20.8547C22.6743 21.0914 22.3139 21.2247 21.938 21.2252H2.06201C1.6861 21.2247 1.32572 21.0914 1.05991 20.8547C0.7941 20.6179 0.644523 20.2968 0.643994 19.962V2.25585C0.644523 1.92097 0.7941 1.59994 1.05991 1.36315C1.32572 1.12635 1.6861 0.993106 2.06201 0.992634H21.938ZM21.938 0.418945H2.06201C1.5153 0.419417 0.991126 0.613107 0.604541 0.957488C0.217956 1.30187 0.000529505 1.76882 0 2.25585V19.962C0.000529505 20.449 0.217956 20.9159 0.604541 21.2603C0.991126 21.6047 1.5153 21.7984 2.06201 21.7989H21.938C22.4845 21.7979 23.0084 21.6041 23.3949 21.2598C23.7813 20.9155 23.9989 20.4488 24 19.962V2.25585C23.9995 1.76882 23.782 1.30187 23.3955 0.957488C23.0089 0.613107 22.4847 0.419417 21.938 0.418945Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 12.4897V19.962C0.64445 20.2969 0.794027 20.6179 1.05984 20.8547C1.32565 21.0915 1.68602 21.2248 2.06194 21.2252H6.33992V12.4951L0.643921 12.4897Z",
    fill: "#E40B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.992676H9.82208V9.38607H23.3561V2.25943C23.3563 2.09331 23.3199 1.92878 23.2487 1.77522C23.1776 1.62165 23.0732 1.48208 22.9416 1.36445C22.8099 1.24682 22.6535 1.15344 22.4813 1.08965C22.3091 1.02587 22.1245 0.99291 21.938 0.992676Z",
    fill: "#E40B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82208 21.2252H21.938C22.314 21.2248 22.6743 21.0915 22.9401 20.8547C23.206 20.6179 23.3555 20.2969 23.3561 19.962V12.4897H9.82208V21.2252Z",
    fill: "#E40B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33992 0.992676H2.06194C1.68602 0.993147 1.32565 1.12639 1.05984 1.36319C0.794027 1.59998 0.64445 1.92101 0.643921 2.25589V9.38253H6.33992V0.992676Z",
    fill: "#E40B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82195 0.992676H6.33992V9.38607H0.643921V12.4897H6.33992V21.2252H9.82195V12.4897H23.3559V9.38607H9.82195V0.992676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmark);
export default __webpack_public_path__ + "static/media/Denmark.a10bd2bfa89ec1c8f75d6a2e485a0acb.svg";
export { ForwardRef as ReactComponent };